import { CSSProperties, FC, SVGAttributes } from 'react'
import SFStartIllustration from '../../assets/svg/smartfren/illustrations/Start.svg'
import SFErrorIllustration from '../../assets/svg/smartfren/illustrations/Error.svg'
import SFFaqIllustration from '../../assets/svg/smartfren/illustrations/FAQ.svg'
import SFInProcessIllustration from '../../assets/svg/smartfren/illustrations/in_process.svg'
import SFInDevelopmentIllustration from '../../assets/svg/smartfren/illustrations/in_development.svg'
import SFTransferIllustration from '../../assets/svg/smartfren/illustrations/Transfer.svg'
import SFSuccessIllustration from '../../assets/svg/smartfren/illustrations/success.svg'
import SFInitIllustration from '../../assets/svg/smartfren/illustrations/init.svg'
import SFSearchNotFound from '../../assets/svg/smartfren/illustrations/init.svg'
import SFHeaderInbox from '../../assets/svg/smartfren/headerIcons/inbox.svg'
import SFHeaderHome from '../../assets/svg/smartfren/headerIcons/home.svg'
import SFHeaderCampaign from '../../assets/svg/smartfren/headerIcons/campaign.svg'
import SFHeaderChannel from '../../assets/svg/smartfren/headerIcons/channel.svg'
import SFHeaderConversation from '../../assets/svg/smartfren/headerIcons/conversation.svg'
import SFHeaderSetting from '../../assets/svg/smartfren/headerIcons/setting.svg'
import SFHeaderAnalytics from '../../assets/svg/smartfren/headerIcons/analytics.svg'
import SFHeaderActiveInbox from '../../assets/svg/smartfren/headerIcons/active/inbox.svg'
import SFHeaderActiveHome from '../../assets/svg/smartfren/headerIcons/active/home.svg'
import SFHeaderActiveCampaign from '../../assets/svg/smartfren/headerIcons/active/campaign.svg'
import SFHeaderActiveChannel from '../../assets/svg/smartfren/headerIcons/active/channel.svg'
import SFHeaderActiveConversation from '../../assets/svg/smartfren/headerIcons/active/conversation.svg'
import SFHeaderActiveSetting from '../../assets/svg/smartfren/headerIcons/active/setting.svg'
import SFHeaderActiveAnalytics from '../../assets/svg/smartfren/headerIcons/active/analytics.svg'
import SFIllustrationSubscribe from '../../assets/svg/smartfren/illustrations/illustration-subscribe.svg'
import SFTextSubscribe from '../../assets/svg/smartfren/illustrations/textSubscribe.svg'
import SFPoweredBy from '../../assets/svg/smartfren/illustrations/powered_by_smartfren.svg'
import GStartIllustration from '../../assets/svg/grahacom/illustrations/Start.svg'
import GErrorIllustration from '../../assets/svg/grahacom/illustrations/Error.svg'
import GFaqIllustration from '../../assets/svg/grahacom/illustrations/FAQ.svg'
import GInProcessIllustration from '../../assets/svg/grahacom/illustrations/in_process.svg'
import GInDevelopmentIllustration from '../../assets/svg/grahacom/illustrations/in_development.svg'
import GTransferIllustration from '../../assets/svg/grahacom/illustrations/Transfer.svg'
import GSuccessIllustration from '../../assets/svg/grahacom/illustrations/success.svg'
import GInitIllustration from '../../assets/svg/grahacom/illustrations/init.svg'
import GSearchNotFound from '../../assets/svg/grahacom/illustrations/init.svg'


const icons: { [key: string]: FC<SVGAttributes<SVGElement>> } = {
  'sf-powered-by': SFPoweredBy,
  'sf-text-subscribe': SFTextSubscribe,
  'sf-illustration-subscribe': SFIllustrationSubscribe,
  'sf-header-inbox-active': SFHeaderActiveInbox,
  'sf-header-home-active': SFHeaderActiveHome,
  'sf-header-campaign-active': SFHeaderActiveCampaign,
  'sf-header-channel-active': SFHeaderActiveChannel,
  'sf-header-conversation-active': SFHeaderActiveConversation,
  'sf-header-setting-active': SFHeaderActiveSetting,
  'sf-header-analytics-active': SFHeaderActiveAnalytics,
  'sf-header-inbox': SFHeaderInbox,
  'sf-header-home': SFHeaderHome,
  'sf-header-campaign': SFHeaderCampaign,
  'sf-header-channel': SFHeaderChannel,
  'sf-header-conversation': SFHeaderConversation,
  'sf-header-setting': SFHeaderSetting,
  'sf-header-analytics': SFHeaderAnalytics,
  ['sf-start']: SFStartIllustration,
  ['sf-error']: SFErrorIllustration,
  ['sf-faq']: SFFaqIllustration,
  ['sf-inProcess']: SFInProcessIllustration,
  ['sf-inDevelopment']: SFInDevelopmentIllustration,
  ['sf-transfer']: SFTransferIllustration,
  ['sf-success']: SFSuccessIllustration,
  ['sf-init']: SFInitIllustration,
  ['sf-search-not-found']: SFSearchNotFound,
  ['g-start']: GStartIllustration,
  ['g-error']: GErrorIllustration,
  ['g-faq']: GFaqIllustration,
  ['g-inProcess']: GInProcessIllustration,
  ['g-inDevelopment']: GInDevelopmentIllustration,
  ['g-transfer']: GTransferIllustration,
  ['g-success']: GSuccessIllustration,
  ['g-init']: GInitIllustration,
  ['g-search-not-found']: GSearchNotFound
}

interface Props {
  name: string,
  width?: any,
  height?: any,
  style?: CSSProperties
}

const IconSVG: FC<Props> = ({ name, ...props }) => {
  const Icon = icons[name]
  return <Icon {...props} color={'black'} />
}

export default IconSVG